import { SSF, utils, WorkBook } from 'xlsx';
import { SpeechNeed } from '../interfaces/Frameworks';
import {
    ClientsImportEntry,
    getClientsImportDateOfBirthColumn,
    ParseClientsImportOptions,
    parseClientsImportRows,
} from './ClientsImport';

// Read formatted spreadsheet values while converting actual DOB date cells to a calendar date.
// Workbooks must be read with cellNF: true so date formats remain available alongside numeric serials.
export function parseClientsImportWorkbook(
    workbook: WorkBook,
    speechNeeds: SpeechNeed[],
    options: ParseClientsImportOptions = {}
): ClientsImportEntry[] {
    const firstSheetName = workbook.SheetNames[0];
    if (!firstSheetName) {
        throw new Error('The selected Excel file does not contain any worksheets.');
    }
    const worksheet = workbook.Sheets[firstSheetName];
    const rawRows = utils.sheet_to_json(worksheet, {
        header: 1,
        raw: false,
        defval: '',
        blankrows: true,
    }) as Array<Array<string | number | boolean | null | undefined>>;
    const rows = rawRows.map(row => row.map(cell => cell == null ? '' : String(cell)));
    const dateOfBirthColumn = getClientsImportDateOfBirthColumn(rows);

    // Keep text dates and every other column unchanged; only Excel date-formatted numbers need conversion.
    if (dateOfBirthColumn !== undefined && worksheet['!ref']) {
        const range = utils.decode_range(worksheet['!ref']);
        const date1904 = workbook.Workbook?.WBProps?.date1904 === true;
        rows.forEach((row, rowIndex) => {
            const cell = worksheet[utils.encode_cell({
                r: range.s.r + rowIndex,
                c: range.s.c + dateOfBirthColumn,
            })];
            if (cell?.t === 'n' && typeof cell.v === 'number' && Number.isFinite(cell.v) &&
                typeof cell.z === 'string' && SSF.is_date(cell.z)) {
                // Serial calendar days honor the workbook epoch without any timezone conversion.
                row[dateOfBirthColumn] = SSF.format('yyyy-mm-dd', Math.floor(cell.v), { date1904 });
            }
        });
    }

    return parseClientsImportRows(rows, speechNeeds, options);
}
